import UtilityService from '../services/utility.service';
import DataService from '../services/data.service';
import NavBarComponent from './nav-bar.component';
import PolyatomicAnionsComponent from './polyatomic-anions.component';
import SolubilityRulesComponent from './solubility-rules.component';
import SolubilityQuizComponent from './solubility-quiz.component';
import NomenclatureQuizComponent from './nomenclature-quiz.component';
import ElementsComponent from './elements.component';
import VisitorsComponent from './visitors-component';

export class FrontPageComponent {
    constructor() {
        this.componentName = "frontPageComponent";
        this.template = `
            <h5>Select a quiz for statistics</h5>
            <table class="table table-hover">
            <thead>
                <tr>
                <th scope="col">Quizzes</th>
                <th scope="col">User Count</th>
                </tr>
            </thead>
            <tbody id="frontPage_row">
                <tr class="table-default" onClick="_cmp.main.hideAll();_cmp.polyatomicAnions.render()">
                    <td scope="row">Polyatomic Anions</td>
                    <td id="polyatomicAnions_Count">{Section}{Count}</td>
                </tr>
                <tr class="table-default" onClick="_cmp.main.hideAll();_cmp.solubilityRules.render()">
                    <td scope="row">Solubility Rules</td>
                    <td id="solubilityRules_Count">{Count}</td>
                </tr>
                <tr class="table-default" onClick="_cmp.main.hideAll();_cmp.solubilityQuiz.render()">
                    <td scope="row">Solubility Quiz</td>
                    <td id="solubilityQuiz_Count">{Count}</td>
                </tr>
                <tr class="table-default" onClick="_cmp.main.hideAll();_cmp.nomenclatureQuiz.render()">
                    <td scope="row">Nomenclature Quiz</td>
                    <td id="nomenclatureQuiz_Count">{Count}</td>
                </tr>
                <tr class="table-default" onClick="_cmp.main.hideAll();_cmp.elements.render()">
                    <td scope="row">Elements</td>
                    <td id="elements_Count">{Count}</td>
                </tr>
                <tr class="table-default" onClick="_cmp.main.hideAll();_cmp.visitors.render()">
                    <td scope="row">Visitors</td>
                    <td id="visitors_Count">{Count}</td>
                </tr>
            </tbody>
            </table>
        `;
        this.cache = undefined;
    }
		
	render() {
		_svc.util.showLoader("#" + this.componentName);
		
		if (this.cacheExpired()) {
			_svc.data.getAllLogs(_cmp.frontPage.postBackSuccess, _cmp.frontPage.postBackFailed);
		} else {
			_svc.util.html("#"+this.componentName, this.cache);
		}
	
		_cmp.navBar.render();
	}
	
	postBackSuccess(response) {
		_svc.util.html("#" + _cmp.frontPage.componentName, _cmp.frontPage.template);
		for(var i = 0; i < response.length; i++) {
			if (response[i].Section == "PolyatomicAnions") {
                _svc.util.html("#polyatomicAnions_Count", response[i].Count)
			}
			if (response[i].Section == "SolubilityRules") {
                _svc.util.html("#solubilityRules_Count", response[i].Count)
			}
			if (response[i].Section == "SolubilityQuiz") {
                _svc.util.html("#solubilityQuiz_Count", response[i].Count)
			}
			if (response[i].Section == "NomenclatureQuiz") {
                _svc.util.html("#nomenclatureQuiz_Count", response[i].Count)
			}
			if (response[i].Section == "Elements") {
                _svc.util.html("#elements_Count", response[i].Count)
			}
			if (response[i].Section == "Visitors") {
                _svc.util.html("#visitors_Count", response[i].Count)
			}
		}
		
		_cmp.frontPage.cache = _svc.util.element(_cmp.frontPage.componentName).innerHTML;
		_cmp.frontPage.cacheExpiration = _svc.util.now() + 60;
	}
	
	postBackFailed(error) {
		console.log("Error in FrontPage - " + error);
	}
		
	hasCache () {
		return this.cache != undefined && this.cacheExpiration != undefined
	}
    
    cacheExpired () {
		if (this.cacheExpiration == undefined) return true;
		if (this.cache == undefined) return true;
		return this.cacheExpiration < _svc.util.now();
	}
}

setTimeout(function(){_cmp.frontPage = new FrontPageComponent()}, 1);